import React from 'react';
import { LinkedinIcon, TwitterIcon, InstagramIcon } from 'lucide-react';
import { Logo } from '../ui/Logo';
export const Footer = () => {
  const currentYear = new Date().getFullYear();
  const scrollTo = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const openCalendly = () => {
    window.open('https://calendly.com/zerototendigital/exploration-feature-design', '_blank');
  };
  return <footer className="bg-white text-black py-16 border-t border-gray-100 relative overflow-hidden" data-id="element-292">
      {/* Background pattern elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-purple-50 rounded-full opacity-40 -mr-32 -mt-32" data-id="element-293"></div>
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-294">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10" data-id="element-295">
          <div className="md:col-span-2" data-id="element-296">
            <div className="mb-6" data-id="element-297">
              <Logo data-id="element-298" />
            </div>
            <p className="max-w-md mb-8 text-text-secondary text-base leading-relaxed" data-id="element-299">
              Your on-demand product management team for AI-powered innovation
              and rapid prototyping. We help companies build better products
              faster, without the overhead of full-time hires.
            </p>
            <button onClick={openCalendly} className="text-primary hover:text-primary-dark transition-colors text-base font-medium" aria-label="Book an introduction call" data-id="element-300">
              Speak with a Senior PM →
            </button>
            {/* Social Media Icons */}
            <div className="flex space-x-4 mt-8" data-id="element-301">
              <a href="https://www.linkedin.com/company/zero-to-ten" target="_blank" rel="noopener noreferrer" className="p-3 bg-purple-50 rounded-full hover:bg-purple-100 transition-colors focus:outline-none focus:ring-2 focus:ring-primary" aria-label="Visit our LinkedIn page" data-id="element-302">
                <LinkedinIcon className="w-5 h-5 text-primary" data-id="element-303" />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="p-3 bg-purple-50 rounded-full hover:bg-purple-100 transition-colors focus:outline-none focus:ring-2 focus:ring-primary" aria-label="Visit our Twitter page" data-id="element-304">
                <TwitterIcon className="w-5 h-5 text-primary" data-id="element-305" />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="p-3 bg-purple-50 rounded-full hover:bg-purple-100 transition-colors focus:outline-none focus:ring-2 focus:ring-primary" aria-label="Visit our Instagram page" data-id="element-306">
                <InstagramIcon className="w-5 h-5 text-primary" data-id="element-307" />
              </a>
            </div>
          </div>
          <div data-id="element-308">
            <h4 className="text-lg font-semibold mb-5 text-black" data-id="element-309">
              Quick Links
            </h4>
            <ul className="space-y-4" data-id="element-310">
              <li data-id="element-311">
                <button onClick={() => scrollTo('benefits')} className="text-text-secondary hover:text-black transition-colors text-base py-1 focus:outline-none focus:text-primary" aria-label="Go to benefits section" data-id="element-312">
                  Benefits
                </button>
              </li>
              <li data-id="element-313">
                <button onClick={() => scrollTo('services')} className="text-text-secondary hover:text-black transition-colors text-base py-1 focus:outline-none focus:text-primary" aria-label="Go to services section" data-id="element-314">
                  Services
                </button>
              </li>
              <li data-id="element-315">
                <button onClick={() => scrollTo('pricing')} className="text-text-secondary hover:text-black transition-colors text-base py-1 focus:outline-none focus:text-primary" aria-label="Go to pricing section" data-id="element-316">
                  Pricing
                </button>
              </li>
              <li data-id="element-317">
                <button onClick={() => scrollTo('faq')} className="text-text-secondary hover:text-black transition-colors text-base py-1 focus:outline-none focus:text-primary" aria-label="Go to FAQ section" data-id="element-318">
                  FAQ
                </button>
              </li>
            </ul>
          </div>
          <div data-id="element-319">
            <h4 className="text-lg font-semibold mb-5 text-black" data-id="element-320">Contact</h4>
            <ul className="space-y-4" data-id="element-321">
              <li className="text-text-secondary text-base leading-relaxed" data-id="element-322">
                <a href="mailto:hello@zerototengrowth.com" className="hover:text-primary transition-colors focus:outline-none focus:text-primary" aria-label="Email us" data-id="element-323">
                  hello@zerototenadvisory.com
                </a>
              </li>
       
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-100 mt-14 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-324">
          <p className="text-text-secondary text-base mb-4 md:mb-0" data-id="element-325">
            © <span id="year" data-id="element-326">{currentYear}</span> ZERO TO TEN. All rights
            reserved.
          </p>
          <div className="flex space-x-8" data-id="element-327">
            <a href="#" className="text-text-secondary hover:text-black transition-colors text-base py-1 px-2 focus:outline-none focus:text-primary" aria-label="View terms of service" data-id="element-328">
              Terms
            </a>
            <a href="#" className="text-text-secondary hover:text-black transition-colors text-base py-1 px-2 focus:outline-none focus:text-primary" aria-label="View privacy policy" data-id="element-329">
              Privacy
            </a>
            <a href="#" className="text-text-secondary hover:text-black transition-colors text-base py-1 px-2 focus:outline-none focus:text-primary" aria-label="View cookie policy" data-id="element-330">
              Cookies
            </a>
          </div>
        </div>
      </div>
    </footer>;
};